import api from './api'

export default {
  inserirDadosNavegador(body){
    const config = {
      headers: { 'Authorization': `${localStorage.getItem('tokenAuthorization')}`}
    };
    return api().post(`/logs/dadosnavegador`, body, config)
  },
}